import React, { useState, useEffect } from "react";
import '../styles/header.css';

const HeaderComponent = () => {
  const messages = [
    "Head to our TikTok/Discord on the right -->",
    "Singles page updated! Check it out!",
    "NEW UPDATE: Logins! Click on our logo below!"
  ];
  
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 5000); // 4 seconds to change the message
  
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
  
  return (
    <div id="header">
      <h1 id="header-banner" className="fade">{messages[currentMessageIndex]}</h1>
      <div id="social-logos">
        <a href="https://www.tiktok.com/@avgpokecollector" target="_blank">
          <img src="\assets\logo\tiktok.png" ></img>
        </a>
        <a href="https://discord.com/invite/q4DyhwpUK9" target="_blank">
          <img src="\assets\logo\discord.png" ></img>
        </a>
      </div>

    </div>
  );
}

export default HeaderComponent;